export const DRAFT = 'draft';
export const ACTIVE = 'published';
export const INACTIVE = 'inactive';
export const UNVERIFIED = 'unverified';
